// ร้านค้าไม่ได้เข้านาน — mirrors GET /dashboard/inactive-stores, /dashboard/inactive-stores/stores
// and /dashboard/inactive-stores/export.

/** Which shops a list request covers: the detail table and On/GROUP use `active`. */
export const INACTIVE_STORE_STATE = {
  active: "active",
  disabled: "disabled",
  all: "all",
} as const;

export type InactiveStoreState = (typeof INACTIVE_STORE_STATE)[keyof typeof INACTIVE_STORE_STATE];

export const INACTIVE_STORE_EXPORT_FORMAT = {
  xlsx: "xlsx",
  csv: "csv",
} as const;

export type InactiveStoreExportFormat =
  (typeof INACTIVE_STORE_EXPORT_FORMAT)[keyof typeof INACTIVE_STORE_EXPORT_FORMAT];

export interface InactiveStoreCountsResponse {
  /** `active_shops + disabled_shops`. */
  total_shops: number;
  /** "On": still active and no bill for at least `days`. */
  active_shops: number;
  /** "ปิดใช้งาน": every disabled shop of the branch, whatever the threshold. */
  disabled_shops: number;
  /** Exactly the keys of `group_columns`; the values sum to `active_shops`. */
  group_shops: Record<string, number>;
}

export interface InactiveStoreBranchResponse extends InactiveStoreCountsResponse {
  branch_code: string;
  branch_name: string | null;
}

export interface InactiveStoreSummaryResponse {
  /** Today in Bangkok, `YYYY-MM-DD`. */
  ref_date: string;
  days: number;
  lookback_days: number;
  /** The fixed 21 GROUP letters plus any other GROUP that has On shops, in display order. */
  group_columns: string[];
  /** The GROUP filter's choices: the columns whose total is above zero. */
  group_options: string[];
  van_options: string[];
  branches: InactiveStoreBranchResponse[];
  totals: InactiveStoreCountsResponse;
}

export interface InactiveStoreResponse {
  customer_uuid: string;
  customer_code: string;
  customer_name: string | null;
  branch_code: string;
  van: string;
  shop_group: string;
  /** `YYYY-MM-DD`; `null` only for a disabled shop with no bill inside the lookback window. */
  last_sale_date: string | null;
  days_since_sale: number | null;
  latitude: number | null;
  longitude: number | null;
  is_disabled: boolean;
}

export interface InactiveStorePageResponse {
  rows: InactiveStoreResponse[];
  count: number;
}

/** Without `days` the server applies the `report.inactive_store.default_days` setting. */
export interface InactiveStoreSummaryParams {
  days?: number;
}

export interface InactiveStoreFilterParams {
  days: number;
  branch_code?: string;
  van?: string;
  shop_group?: string;
  search?: string;
}

export interface InactiveStoreListQuery extends InactiveStoreFilterParams {
  state: InactiveStoreState;
}

export interface InactiveStoreListParams extends InactiveStoreListQuery {
  page: number;
  limit: number;
}

export interface InactiveStoreExportParams extends InactiveStoreFilterParams {
  format: InactiveStoreExportFormat;
}
